import { Action, Dispatch } from "redux";
import axios from "../../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import * as action_types from "./constants";
import {
  GetServiceLinePayloadType,
  GetServiceListingPayloadType,
} from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getServiceLineListing = (payload: GetServiceLinePayloadType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getServiceLineListing`,
        payload
      );
      dispatch({
        type: action_types.GET_SERVICE_LINE_LISTING,
        data: { payload: data?.data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_SERVICE_LINE_LISTING,
        payload: { loading: false },
      });
    }
  };
};

export const removeServiceLineListing = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_SERVICE_LINE_LISTING,
      data: { payload: {}, loading: true },
    });
  };
};

export const getServiceLineDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getServiceLineDetails/${id}`);
      dispatch({
        type: action_types.GET_SERVICE_LINE_DETAILS,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_SERVICE_LINE_DETAILS,
        payload: { loading: false },
      });
    }
  };
};

export const getServiceDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getServiceDetails/${id}`);
      dispatch({
        type: action_types.GET_SERVICE_DETAILS,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_SERVICE_DETAILS,
        payload: { loading: false },
      });
    }
  };
};

export const removeServiceDetails = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_SERVICE_DETAILS,
      data: { payload: {}, loading: true },
    });
  };
};

export const getServiceListing = (payload: GetServiceListingPayloadType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(`${baseURL}getServiceListing`, payload);
      dispatch({
        type: action_types.GET_SERVICE_LISTING,
        data: { payload: data?.data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_SERVICE_LISTING,
        payload: { loading: false },
      });
    }
  };
};

export const removeServiceListing = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_SERVICE_LISTING,
      data: { payload: null, loading: true },
    });
  };
};

export const getServiceFormData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getServiceFormData/${id}`);
      dispatch({
        type: action_types.SERVICE_FORM_DATA,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.SERVICE_FORM_DATA,
        payload: { loading: false },
      });
    }
  };
};

export const getFrequencyForChild = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getFrequencyForChild/${id}`);
      dispatch({
        type: action_types.GET_FREQUENCY_FOR_CHILD,
        data: { payload: data },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_FREQUENCY_FOR_CHILD,
        payload: { loading: false },
      });
    }
  };
};
